import type { TranscriptFormattingPort } from '@/shared-responder-v2-core';

export interface TranscriptFormatQueryResult {
  readonly data?: {
    readonly formattedTranscriptAnswer: {
      readonly formattedTranscript: string;
    };
  } | null;
  readonly error?: unknown;
}

type TranscriptFormatQueryRunner = (
  transcript: string
) => Promise<TranscriptFormatQueryResult>;

function toFormattedTranscript(
  result: TranscriptFormatQueryResult
): string | null {
  const failed = result.error !== undefined && result.error !== null;
  const formatted =
    result.data?.formattedTranscriptAnswer.formattedTranscript.trim() ?? '';

  return failed || formatted === '' ? null : formatted;
}

export function createTranscriptFormattingPort(
  run: TranscriptFormatQueryRunner
): TranscriptFormattingPort {
  return {
    isAvailable: true,
    format: async (transcript) => {
      try {
        return toFormattedTranscript(await run(transcript));
      } catch {
        return null;
      }
    },
  };
}
